/* eslint-disable */
const namespace = 'ANDROIDENCRYPTMODULE'; // android 加固模块namespace
const GETAPKINFO = `${namespace}getApkInfo`; // 获取apk 解析信息
const GETGROUPLIST = `${namespace}getGroupList`; // 获取项目组list
const GETTHREATSCENARIOS = `${namespace}getThreatScenarios`; // 获取加固策略的加固项
export { GETGROUPLIST, GETTHREATSCENARIOS, GETAPKINFO };
